export const ERROR = {
    400: "BAD REQUEST",
    401: "UNAUTHORIZED",
    403: "FORBIDDEN",
    404: "NOT FOUND",
    500: "INTERNAL SERVER ERROR"
};